import React, { useState, useContext } from 'react';
import { GlobalContext } from '../../../Context/GlobalContext';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import FormLabel  from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {
  useStripe, 
  useElements, 
  CardElement,
} from '@stripe/react-stripe-js';

const SetupForm = ({ 
  customerId,
  connectedStripeId,
  setCardDetails,
  setDisplayCardForm, 
  clientSecret 
}) => {

  const API_URL = 'https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com';
  const { viewerObj } = useContext(GlobalContext);

  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState('');
  const [cardHolderName, setCardHolderName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const submitCardDetails = async (event) => {
    event.preventDefault();

    // erase previous error message
    setErrorMessage('');
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    setIsLoading(true);
    // send card details and confirm the setupIntent
    const result = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: {
          email: viewerObj.email,
          name: cardHolderName,
          address: { "country": "US" }
        }
      }
    });

    // check if there was an error saving the viewer's payment method
    if (result.error) {
      // Display error message returned from stripe
      setErrorMessage(result.error.message)
      setIsLoading(false)
    } else {
      // The setup has succeeded. Fetch card details to present to the viewer
      const { data } = await axios.post(`${API_URL}/retrieve-payment-methods`, {
        customerId,
        connectedStripeId
      })

      const paymentMethodArray = data.data;
      setCardDetails(paymentMethodArray[0]);
      setIsLoading(false);
      setDisplayCardForm(false);
    }
  };

  return(
    <Grid container item>

      {errorMessage && 
        <Alert variant="filled" severity="error">
          {errorMessage}
        </Alert>
      }

      {stripe && elements &&
        <form onSubmit={submitCardDetails}>
          <FormLabel>Name on card</FormLabel>
          <TextField
            fullWidth
            value={cardHolderName}  
            type='text'
            name="line1"
            onChange={ ({ target }) => setCardHolderName(target.value) }
            variant="outlined" 
            placeholder='John Smith'
            required/>
          <CardElement />
          <Button 
            fullWidth
            type="submit"
            color="primary"
            disabled={isLoading}
            variant="contained"
          >
            Save 
          </Button>
          <Button 
            fullWidth
            color="primary"
            variant="text"
            disabled={isLoading}
            onClick={() => setDisplayCardForm(false)}
          >
            cancel
          </Button>
        </form>
      }
      {!stripe && !elements &&
        <div>Loading...</div>
      }
    </Grid>

  )
};

export default SetupForm;